export default "__VITE_ASSET__5c0e5767__"